import script from "./AssigneeControl.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeControl.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeControl.vue?vue&type=style&index=0&id=4737944a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4737944a"]])

export default __exports__